export default __webpack_public_path__ + "static/media/fantom.192bbd96.svg";